/**
 * DOVE VIVE IL BACKEND DELLE MISSIONI — e SOLO quello.
 *
 * 🔴 Questo valore non e' un flag di Limulo. `featureLimuloEnabled` dice «la sezione Limulo
 * di questa build e' accesa»; qui si dice «la lista delle missioni la serve X». Sono due
 * fatti diversi e oggi coincidono per caso, non per costruzione: il giorno che Limulo si
 * accende in produzione SENZA che `packages/app-quest` sia su `main` — cioe' senza che il
 * BFF esponga `GET /v1/missions` — un valore derivato dal flag manderebbe le missioni contro
 * una rotta che non esiste, e **nessun test sarebbe rosso**, perche' nessun test puo'
 * misurare da qui il contenuto di un altro repo. Un nome proprio rende quel giorno una
 * DECISIONE (qualcuno scrive la riga) invece che una conseguenza.
 *
 * [M 2026-09-15T18:57Z, `gh api .../contents/packages?ref=…`] `app-quest` c'e' su
 * `Qlash-IT/qlash-limulo@staging` (29 pacchetti) e NON su `main` (22): staging e' oggi
 * l'unico ambiente in cui le missioni possono venire da Limulo.
 *
 * ⚠️ OPT-IN, e nel verso che protegge la produzione: tutto cio' che non e' esattamente
 * `'limulo'` vale `'quest'`, che e' la via FUNZIONANTE. Un refuso in un `.env` non dirotta
 * le missioni: le lascia dove sono. Il refuso lo prende `tools/verify-missions-backend.ts`,
 * che legge i quattro file e pretende un valore dichiarato in ognuno — perche' questa
 * ricaduta silenziosa da sola sarebbe l'altra meta' del problema.
 */
export type MissionsBackend = 'quest' | 'limulo';

/** Il valore che il default NON puo' produrre: si scrive per esteso, una volta sola. */
export const MISSIONS_BACKEND_LIMULO = 'limulo' satisfies MissionsBackend;

/**
 * Pura, e per la stessa ragione di `lib/limulo/config.ts`: cosi' la regola si esercita
 * sotto Node — dove `import.meta.env` non esiste — invece che solo dentro una build.
 */
export function resolveMissionsBackend(raw: string | undefined): MissionsBackend {
  return raw === MISSIONS_BACKEND_LIMULO ? 'limulo' : 'quest';
}
